export function picksBody(bookId, benefits) {
	const subscriptions = Array.isArray(benefits) ? benefits : [];
	const subscription = subscriptions.find((item) => item.remaining == null || Number(item.remaining) > 0) || subscriptions[0];
	return subscription?.id
		? { booksToSubscribe: bookId, benefit_id: subscription.id }
		: { booksToSubscribe: bookId };
}
